const navbarToggler = document.querySelector(".js--navbar-toggler");
const burger = document.querySelector(".js--burger");
const navbar = document.querySelector(".js--navbar");

navbarToggler.addEventListener("click", () => {
	burger.classList.toggle("open");
	navbar.classList.toggle("collapse");
});
